import request from '@/utils/request'

export function GetMySocialMediaClient(params) {
  return request({
    url: '/socialmedia/getmysocialmediaclient',
    method: 'get',
    params: params
  })
}

export function GetCompanySellerList(params) {
  return request({
    url: '/socialmedia/getcompanysellerlist',
    method: 'get',
    params: params
  })
}

export function SetClientDetail2Seller(params) {
  return request({
    url: '/socialmedia/setclientdetail2seller',
    method: 'get',
    params: params
  })
}

export function SaveMediaOperatorNote(params) {
  return request({
    url: '/socialmedia/savemediaoperatornote',
    method: 'get',
    params: params
  })
}

export function GetSocialMediaDashboardData(params) {
  return request({
    url: '/socialmedia/getsocialmediadashboarddata',
    method: 'get',
    params: params
  })
}
